import {Component} from 'react';
import {getAspaAvailable} from './lib/droits.js';
import {DroitCell} from './droit-cell';
import PositiveResult from './Positive-result';
import NegativeResult from './Negative-result';

class Resultats extends Component {

	constructor(props){
		super(props);

		const isIneligibleByAge = this.props.ineligibleByAge || Number(this.props.demandeur?.age) < 65;

		this.state = {
			aspa: null,
			loading: !isIneligibleByAge,
		}

		if (isIneligibleByAge) {
			return;
		}

        var entities = { ...this.props };

        entities.demandeur.rfr = null;
        if ( entities.conjoint && Object.keys(entities.conjoint).length > 0 ) {
            entities.famille.parents = ['individu', 'conjoint'];
            entities.menage.conjoint = ['conjoint'];
            entities.foyer_fiscal.declarants =['individu', 'conjoint'];
        }

        entities.foyer_fiscal.personnes_a_charge=[];
        entities.menage.enfants=[];
        entities.famille.enfants=[];
        entities.menage.cheque_energie = null;

        Object.keys(entities.individus).forEach ((individu)=>{
            if ( individu !== 'demandeur' && individu !== 'conjoint' ) {
                entities.foyer_fiscal.personnes_a_charge.push(individu);
                entities.menage.enfants.push(individu);
                entities.famille.enfants.push(individu);
            }
        });
        entities.menage.logement_conventionne =
          entities.menage.statut_occupation_logement &&
          entities.menage.statut_occupation_logement === 'primo_accedant' &&
          entities.menage.loyer &&
          entities.menage.loyer === 0;

        delete entities.demandeur.date_fin_contrat;
        if ( typeof entities.conjoint !== 'undefined' ){
            entities.conjoint.statut_marital = entities.demandeur.statut_marital;
        }
        
        const requestURI = "https://simulateurs.aide-sociale.fr/simulateur-backend-test/of.php" ; //openfisca
        
        var data = {
            'individus':  {
                ...entities.individus
                ,...{
                    'individu' : entities.demandeur,
                    'conjoint' : entities.conjoint,
                }
            },
            'familles' : {
                _ : entities.famille,
            },
            'foyers_fiscaux' : {
                _ : entities.foyer_fiscal,
            },
            'menages': {
                _ : entities.menage,
            }
        };

        data.menages._.aide_logement_date_pret_conventionne = (new Date().getFullYear() - 4).toString() + '-12-31';

        Object.keys(data).forEach( (entity)=>{
            data[entity] = JSON.stringify(data[entity]);
        });

        const request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },

            body:JSON.stringify(data)
        };

        fetch(requestURI ,request)
            .then((res)=> {
                return res.json();
            })
            .then ((json)=>{
                console.log(json);
                this.setState({
                    loading: false,
                    aspa: getAspaAvailable(json.openfisca),
                });
            });
    }

    restart = ()=>{
        this.props.restart();
    }

    render(){
        const currentYear = new Date().getFullYear();
        const [anneeN2 , anneeN1] = [currentYear-2 , currentYear-1];

		return <div className="step-inner-container">

			{ ( this.state.loading ) ?
				<>
				  <div className="loader"></div>
				  <p className="text-center">Chargement des résultats...</p>
				</>
				: <div className="resultats">

					<div className="information">
					  <p>{this.state.aspa
						? <PositiveResult model={this.state.aspa} />
						: <NegativeResult /> }</p>
					</div>
					
    				<div className="result-button button-container previous">
    						<button onClick={this.restart}> Recommencer </button>
    				</div>

                </div>}
        </div>
    }
}


export default Resultats;
